export default {
  allVehicleGroups: [],
  vehicleGroup: {},
}
